import { RelayState } from '@/store/modules/relay/relayState';

const state: RelayState = {
    relays: [],
    activeServer: null,
};

export default state;
